module.exports = __webpack_public_path__ + "img/71_21.60646ec4.png";